<template>
    <main class="pro">
        <!-- <div class="banner">
            <div class="text">
                <h3>专业品质</h3>
                <h5>Professional quality, leading in India</h5>
                <h2>成就印界翘楚</h2>
            </div>
        </div> -->
        <slide-show :data="$root.banners" :ratio="'0.21'"></slide-show>
        <div class="content">
            <div class="tip">
                <!-- <div class="active">我们的服务</div>
                <div>产品展示</div>
                <div>设备介绍</div> -->
                <router-link to="/products/server" :class="{ 'active': $route.path == '/products' || $route.path == '/products/server' }">{{ lang('nav_pro_printing') }}</router-link>
                <router-link to="/products/display" :class="{ 'active': $route.path == '/products/display' }">{{ lang('nav_pro_display') }}</router-link>
                <router-link to="/products/equipment" :class="{ 'active': $route.path == '/products/equipment' }">{{ lang('nav_pro_equipment') }}</router-link>
            </div>

            <router-view class="fadeIn"></router-view>

        </div>
    </main>
</template>
<style lang="less" scoped>
@red: #e60012;

.banner {
    height: 550px;
    background: url(../assets/images/tech/banner.jpg) center/cover no-repeat;
    display: flex;
    align-items: center;
    margin-bottom: 30px;

    .text {
        position: relative;
        text-align: left;
        color: #FEFEFE;
        padding-left: 456px;

        h3 {
            font-size: 71px;
            line-height: 71px;
            font-weight: 400;
            margin: 0;
        }

        h5 {
            font-size: 24px;
            font-weight: 400;
            margin: 16px 0;
        }

        h2 {
            font-size: 96px;
            line-height: 96px;
            font-weight: 400;
            margin: 0;
        }

        .corner {
            position: absolute;
            border: 2px solid transparent;
            width: 42px;
            height: 42px;

            &.lt {
                left: 0;
                top: 0;
                border-left-color: white;
                border-top-color: white;
            }

            &.rt {
                right: 0;
                top: 0;
                border-right-color: white;
                border-top-color: white;
            }

            &.rb {
                right: 0;
                bottom: 0;
                border-right-color: white;
                border-bottom-color: white;
            }

            &.lb {
                left: 0;
                bottom: 0;
                border-left-color: white;
                border-bottom-color: white;
            }
        }
    }
}

.pro {
    min-width: 1664px;

    .content {
        padding-bottom: 10px;
        margin-top: 30px;

        .tip {
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 20px;
            font-weight: 400;
            color: #353535;
            margin-bottom: 40px;

            a {
                display: inline-block;
                padding: 0 78px;
                height: 22px;
                line-height: 22px;

                &:not(:last-child) {
                    border-right: 1px dashed #333333;
                }

                &.active {
                    color: @red;
                    font-weight: bold;
                }
            }
        }
    }
}

@media screen and (max-width: 1360px) {
    .pro {
        min-width: auto;

        .content {
            margin-top: 0;

            .tip {
                white-space: nowrap;
                overflow: auto;
                display: block;
                margin-bottom: 0;
                text-align: center;
                border-bottom: 1px solid #ddd;

                a {
                    height: auto;
                    display: inline-flex;
                    padding: 15px 20px;

                    &:not(:last-child) {
                        border-right: none;
                    }
                }
            }
        }
    }
}
</style>
<script>
export default {
    data() {
        return {

        }
    },
    methods: {

    },
    mounted() {
        // this.getCompanyList(4);
        if (this.$root.groupId) {
            this.$root.getBanner(4);
        }
    },
    watch: {

    }
}
</script>